<div class="part-product-cart">
  <app-sap-message-controller [messages]="cartSapMessages"/>
  @if (!isCartEmpty() || (isMyInstalledBaseFlowEnabled && currentCart.attributes.systemDetails?.siemensEquipmentId)) {
    <div class="multi-cart__current-cart">
      <div class="display-flex">
        <h5 [attr.data-test]="'title-selectedCart'">{{ 'multi-cart.selected-cart' | translate }}</h5>
        @if (isProductWithMaterialMasterNumber()) {
          <div
            class="material-master-number-notification">
            <app-product-information-notification
              [margin]="false"
              />
          </div>
        }
      </div>
      <div class="selected-cart"
        [ngClass]="isProductWithMaterialMasterNumber() ? 'margin-top-0' : 'margin-top-2'">
        @if ((isAddingViaCsvInProgress || disabledAddToCartSearchBar) || loadingCart) {
          <div class="selected-cart-loader">
            <div class="loading-animation"></div>
          </div>
        }
        <div class="selected-cart-container">
          <div class="selected-cart-header">
            <div class="selected-cart-details">
              <h6 class="selected-cart-name" [attr.data-test]="'title-selectedCartName'">
                {{ getCurrentCartName() }}
              </h6>
              <button type="submit" class="button button--link button--add-nickname button--auto-min-width"
                [attr.data-test]="'title-addNickname'"
                (click)="showAddNicknameModalEmit()">
                {{ getLabelForAddNicknameButton() | translate }}
              </button>
              @if (isMyInstalledBaseFlowEnabled && !isPredefinedEquipmentFlowEnabled) {
                <div class="system-details">
                  <app-equipment-selection
                    [currentCart]="currentCart"
                    [systemDetails]="currentCart.attributes.systemDetails"
                    [loading]="false"
                    [isInCurrentCartComponent]="true"
                    [isEquipmentRequired]="currentCart.attributes.isEquipmentRequired">
                  </app-equipment-selection>
                </div>
              }
              @if (isPredefinedEquipmentFlowEnabled) {
                <div class="system-details">
                  <h6 [attr.data-test]="'desc-systemName'">{{ currentCart.attributes.systemDetails?.nameEnUs }}</h6>
                  <span [attr.data-test]="'desc-functionalLocationNumber'">
                    {{ "multi-cart.functional-location" | translate }} {{ currentCart.attributes.systemDetails?.functionalLocation }}
                  </span>
                </div>
              }
            </div>
            <button type="submit" class="button button--link button--delete-cart button--auto-min-width"
              (click)="showDeleteCartModalEmit()" [attr.data-test]="'button-deleteCart'">
              {{ 'multi-cart.delete-cart' | translate }} <span class="icon-close"></span>
            </button>
          </div>
          @if (isEquipmentAfterEos()) {
            <div class="eos-message">
              <app-message [message]="setDataForEquipmentAfterEosMessage()"></app-message>
            </div>
          }
          <div class="cart-items-list-container">
            <div class="list-header">
              <div class="header-col item-image blank"></div>
              <div class="header-col item-info blank"
              [ngClass]="(!isPriceVisibleInListHeader()) ? 'item-info__rfq-only-width' : 'item-info__width'"></div>
              @if (isPriceVisibleInListHeader()) {
                <div
                  class="header-col item-price">{{ 'multi-cart.price-per-unit' | translate }}
                </div>
              }
              <div class="header-col item-quantity">{{ 'multi-cart.quantity' | translate }}</div>
              @if (isPriceVisibleInListHeader()) {
                <div
                  class="header-col item-total-price">{{ 'multi-cart.total-price' | translate }}
                </div>
              }
            </div>
            @let isDeliveryAvailabilityEnabled = isDeliveryAvailabilityEnabled$ | async;
            @for (item of currentCartItems; track item; let index = $index) {
              <div class="item-row" [attr.data-test]="'cart-item-' + item.attributes.name">
                <div class="mobile-item-actions hidden-lg-up" [attr.data-test]="'section-mobileWishlist'">
                  @if (isWishlistsActive) {
                    <div class="wishlist">
                      <app-add-to-wishlist
                        [wishlists]="wishlists"
                        [sku]="item.id"
                        [productName]="item.attributes.name"
                        [productKeywords]="item.attributes.attributes?.mcm_keywords"
                        [addNewModalActive]="addWishlistModalActive"
                        [textNextToIcon]="true"
                        (createNew)="showAddWishlistModalEmit()">
                      </app-add-to-wishlist>
                    </div>
                  }
                  @if (!isPriceDisputingActive) {
                    <button
                      class="button button--link button--delete-item"
                      [attr.data-test]="'button-remove-item-form-cart'"
                      (click)="removeCartItemEmit(item.id)">
                      {{ 'multi-cart.delete-item' | translate }} <span class="icon-close"></span>
                    </button>
                  }
                </div>
                <div class="item-col item-image">
                  <img [src]="getImageForCartItem(item)" alt="{{ item.attributes.name }}"
                    [attr.data-test]="'img-itemImage'">
                </div>
                <div class="item-col item-info"
                  [ngClass]="!isRfqFlowInactive() ? 'item-info__rfq-only-width' : 'item-info__width'">
                  <h6 class="item-name" [attr.data-test]="'title-itemName'">
                    <a [routerLink]="['/product/', item.attributes.abstractSku]">
                    {{ item.attributes.name || item.attributes.attributes?.sap_name }}</a>
                  </h6>
                  @if (isRfqFlowInactive()) {
                    @if (isProductTagsActive) {
                      <div class="cart-items-tags">
                        @if ((isProductDiscontinuedStatusEnabled$ | async) && item.attributes.isDiscontinued) {
                          <span
                            class="label discontinued-item"
                            [attr.data-test]="'label-discontinuedItem'">
                            {{ 'spare-parts.discontinued-item' | translate }}
                          </span>
                        }
                        @if (item.attributes.isExchangeable || item.attributes.availability?.isExchangeable) {
                          <span
                            class="label item-exchange-material"
                            [attr.data-test]="'desc-itemExchangeable'">
                            {{ 'spare-parts.exchangeable-item' | translate }}
                          </span>
                        }
                        @if (isSapStore && item.attributes.heavyweight) {
                          <span
                            class="label heavyweight-item"
                            [attr.data-test]="'desc-heavyweightItem'">
                            {{ 'spare-parts.heavyweight-item' | translate }}
                          </span>
                        }
                      </div>
                    }
                    <p class="item-details">
                      <span class="item-material-number"
                      [attr.data-test]="'desc-itemMaterialNumber'">{{ item.attributes.materialNumber }}</span><br>
                      @if (isDeliveryAvailabilityEnabled) {
                        <span class="item-delivery-availability">
                          @if (isSapStore) {
                            @if (item.attributes.availability?.isAvailable) {
                              <span
                                  [attr.data-test]="'desc-itemDeliveryAvailability'">
                                {{ 'spare-parts.in-stock' | translate }}
                              </span>
                            } @else {
                              <span>
                                {{ 'spare-parts.out-of-stock' | translate }}
                              </span>
                            }
                          } @else {
                            @if (item.attributes.deliveryAvailability) {
                              <span
                                  [attr.data-test]="'desc-itemDeliveryAvailability'">
                                {{ item.attributes.deliveryAvailability }}
                              </span>
                            }
                          }
                        </span>
                      }
                    </p>
                  }
                  <app-advanced-product-information
                    [currentItem]="item"
                    [currentCartId]="currentCart.id"
                    [currentCartItems]="currentCartItems"
                    [isEditingEnabled]="true"
                    (checkAllRequiredValues)="checkAllRequiredValues($event)">
                  </app-advanced-product-information>
                  @if (isWishlistsActive) {
                    <div class="wishlist" [ngClass]="{'wishlist__rfq': rfqActive}"
                      [attr.data-test]="'section-desktopWishlist'">
                      <app-add-to-wishlist
                        [wishlists]="wishlists"
                        [sku]="item.id"
                        [productName]="item.attributes.name"
                        [productKeywords]="item.attributes.attributes?.mcm_keywords"
                        [addNewModalActive]="addWishlistModalActive"
                        [textNextToIcon]="true"
                        (createNew)="showAddWishlistModalEmit()">
                      </app-add-to-wishlist>
                    </div>
                  }
                </div>
                @if (isRfqFlowInactive()) {
                  <div class="item-col item-price">
                    <span class="item-unit-price"
                      [attr.data-test]="'desc-itemUnitPrice'">{{ item.attributes.calculations.unitPrice | currency: currency }}
                      @if (isExcludeTaxActive()) {
                        <span class="tax-disclaimer" [attr.data-test]="'desc-taxDisclaimer'">
                        ({{ 'app-product-page.ex_gst' | translate }})</span>
                      }</span>
                    </div>
                  }
                  @if ((isMobile | async) === false) {
                    <div class="item-col item-quantity">
                      <form
                        (submit)="updateCartItemQuantityEmit(item.attributes.quantity, itemQuantity.value, item, index)">
                        <input #itemQuantity
                          type="number"
                          name="itemQuantity"
                          class="item-quantity"
                          [value]="item.attributes.quantity"
                          min="1"
                          step="1"
                          required
                          (change)="updateCartItemQuantityEmit(item.attributes.quantity, itemQuantity.value, item, index)"
                          [attr.data-test]="'input-itemQuantityCurrentCart'"/>
                      </form>
                      @if (!isRfqFlowInactive() && !isPriceDisputingActive) {
                        <button
                          class="button button--link button--delete-item__rfq-only"
                          [attr.data-test]="'button-removeItemFormCartRfqOnly'"
                          (click)="removeCartItemEmit(item.id)">
                          {{ 'multi-cart.delete-item' | translate }} <span class="icon-close"></span>
                        </button>
                      }
                    </div>
                  }
                  @if (isRfqFlowInactive()) {
                    <div class="item-col item-total-price">
                      <span class="item-total-price"
                        [attr.data-test]="'desc-itemTotalPrice'">{{ item.attributes.calculations.sumPrice | currency: currency }}
                        @if (isExcludeTaxActive()) {
                          <span class="tax-disclaimer" [attr.data-test]="'desc-taxDisclaimer'">
                            ({{ 'app-product-page.ex_gst' | translate }})
                          </span>
                        }
                      </span>
                      @if (!isPriceDisputingActive) {
                        <button
                          class="button button--link button--delete-item"
                          (click)="removeCartItemEmit(item.id)"
                          [attr.data-test]="'button-remove-item-form-cart'">
                          {{ 'multi-cart.delete-item' | translate }} <span class="icon-close"></span>
                        </button>
                      }
                    </div>
                  }
                  @if (isMobile | async) {
                    <div class="mobile-item-header hidden-lg-up">
                      @if (isRfqFlowInactive()) {
                        <div class="item-price">
                          <strong>{{ 'multi-cart.price-per-unit' | translate }}</strong></div>
                        }
                        <div class="item-quantity"><strong>{{ 'multi-cart.quantity' | translate }}</strong></div>
                        @if (isRfqFlowInactive()) {
                          <div class="item-total-price">
                            <strong>{{ 'multi-cart.total-price' | translate }}</strong></div>
                          }
                        </div>
                        <div class="mobile-item-price hidden-lg-up">
                          @if (isRfqFlowInactive()) {
                            <div
                              class="item-unit-price"
                              [attr.data-test]="'item-unit-price'">{{ item.attributes.calculations.unitPrice | currency: currency }}
                            </div>
                          }
                          <div class="item-quantity">
                            <form
                              (submit)="updateCartItemQuantityEmit(item.attributes.quantity, itemQuantity.value, item, index)">
                              <input #itemQuantity
                                type="number"
                                name="itemQuantity"
                                class="item-quantity"
                                [value]="item.attributes.quantity"
                                min="1"
                                step="1"
                                required
                                (change)="updateCartItemQuantityEmit(item.attributes.quantity, itemQuantity.value, item, index)"
                                [attr.data-test]="'input-itemQuantity'"/>
                            </form>
                          </div>
                          @if (isRfqFlowInactive()) {
                            <div
                              class="item-total-price"
                              [attr.data-test]="'item-total-price'">{{ item.attributes.calculations.sumPrice | currency: currency }}
                            </div>
                          }
                        </div>
                      }
                    </div>
                    @if (isPriceDisputingActive) {
                      <div
                        class="item-price-disputing-row">
                        <app-price-disputing
                          [currentCart]="currentCart"
                          [currentItem]="item"
                          [isSaturdayShipment]="isSaturdayShipment"
                          (removeCartItem)="removeCartItemEmit($event)">
                        </app-price-disputing>
                      </div>
                    }
                    <hr>
                    }
                    @if (isSaturdayShipment && isBusinessPartnerRole) {
                      <p class="disclaimer--shipment-method">
                        {{ 'checkout-delivery-details.saturday-delivery-method-price-disputing-disclaimer' | translate }}
                      </p>
                    }
                    @if (isCartEmpty() && (isSapStore || isMyInstalledBaseFlowEnabled)) {
                      <div class="no-items-in-current-cart">
                        <h6 class="empty-cart-header">
                          {{ 'multi-cart.empty-cart-title-us-support-add-to-cart-from-file' | translate }}
                        </h6>
                      </div>
                    }
                  </div>
                </div>
                <div class="selected-cart-summary">
                  <div class="action-buttons">
                    <button
                      [attr.data-test]="'button-continueToCheckout'"
                      type="submit" class="button button--primary"
                      [disabled]="!isMinimumOrderValue() || currentCartItems?.length === 0 || !isMaterialMasterNumberFulfilled"
                      (click)="proceedToNextStep()">
                      {{ getLabelForContinueToCheckoutButton() | translate }}
                    </button>
                    @if (isExportCartActive && isRfqFlowInactive()) {
                      @if (!fileGenerationInProgress) {
                        <button
                          [attr.data-test]="'button-exportShoppingCart'"
                          type="button"
                          class="button button--secondary"
                          (click)="generatePdfFileEmit()">
                          {{ 'multi-cart.export-shopping-cart' | translate }}
                        </button>
                      } @else {
                        <div class="btn-spinner">
                          <div class="loading-animation"></div>
                        </div>
                      }
                    }
                    <button
                      [attr.data-test]="'button-continueShopping'"
                      type="button" class="button button--secondary" [routerLink]="['/catalog/parts']">
                      {{ 'multi-cart.continue-shopping' | translate }}
                    </button>
                  </div>
                  @if (isSapStore && isRfqFlowInactive()) {
                    <div class="selected-cart-pricelist">
                      <div class="price-disclaimer">
                        <strong [attr.data-test]="'label-totalPrice'">{{ 'multi-cart.total-price' | translate }}</strong><br>
                      </div>
                      <div class="current-cart-total-price" [attr.data-test]="'desc-subtotal-for-usStore'">
                        <strong>{{ currentCart.attributes.totals.subtotal | currency: currency }}</strong>
                      </div>
                    </div>
                    <section>
                      @if (hasSapDiscounts()) {
                        <span> {{ 'multi-cart.total-price-with-discount' | translate }}</span>
                      } @else {
                        <span> {{ 'multi-cart.exclude-tax' | translate }}</span>
                      }
                    </section>
                  } @else {
                    @if (isRfqFlowInactive()) {
                      <div class="selected-cart-pricelist other-store">
                        @if (!isMinimumOrderValue()) {
                          <div class="min-order-value">
                            <strong>
                              {{ 'shop-cart.minimum-order-value' | translate }}
                            </strong>
                          </div>
                        }
                        <div class="total-price-container">
                          <strong [attr.data-test]="'label-subtotal-for-otherStore'">
                            {{ 'multi-cart.total-price' | translate }}
                          </strong>
                          <strong [attr.data-test]="'desc-subtotal-for-otherStore'">
                            {{ currentCart.attributes.totals.subtotal | currency: currency }}
                          </strong>
                        </div>
                        @if (showPriceDisclaimer) {
                          <p>
                            <span [attr.data-test]="'label-excludes-vat'">
                              {{ 'shop-cart.excludes-vat' | translate }}
                            </span>
                            <br/>
                            <span [attr.data-test]="'label-pricing-validation'">
                              {{ 'shop-cart.pricing-validation' | translate }}
                            </span>
                          </p>
                        } @else {
                          @if (isExcludeTaxActive()) {
                            <p class="totals-tax-disclaimer">
                              <span [attr.data-test]="'desc-taxDisclaimer'">
                                ({{ 'app-product-page.ex_gst' | translate }})
                              </span>
                            </p>
                          } @else {
                            <p>
                              <span [attr.data-test]="'label-additional-information'">
                                {{ 'shop-cart.totalAdditionalInformation' | translate }}
                              </span>
                              <br>
                                <span [attr.data-test]="'label-free-shipping'">
                                  {{ 'shop-cart.free-shipping' | translate }}
                                </span>
                              </p>
                            }
                          }
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
            } @else {
              <div class="multi-cart__empty-cart">
                <div class="empty-cart-wrapper">
                  <h6 class="empty-cart-header">
                    {{ 'multi-cart.empty-cart-title' | translate }}
                  </h6>
                  @if (isSapStore || isMyInstalledBaseFlowEnabled) {
                    <p class="empty-cart-text">
                      {{ 'multi-cart.empty-cart-text' | translate }}
                    </p>
                  }
                  <button class="button" [routerLink]="['/catalog/parts']">
                    {{ 'multi-cart.catalog-link' | translate }}
                  </button>
                  @if (isSapStore || isMyInstalledBaseFlowEnabled) {
                    <button
                      [attr.data-test]="'button-goToInstalledBase'"
                      class="button button--installed-base"
                      [routerLink]="[isBusinessPartnerRole ? '/equipment-selection' : '/my-installed-base']"
                      [queryParams]="isBusinessPartnerRole ? {} : {tab : EInstalledBaseTabs.EQUIPMENT}">
                      {{ (isBusinessPartnerRole ? 'multi-cart.equipment-link-bp' : 'multi-cart.equipment-link') | translate }}
                    </button>
                  }
                </div>
                @if (loadingCart) {
                  <div class="empty-cart-loader">
                    <div class="loading-animation"></div>
                  </div>
                }
              </div>
            }
            @if (isSpecialAddToCartSectionEnabled()) {
              <div class="add-directly-to-cart-container">
                <div class="add-via-searchbar-container">
                  @if (featureIsEnabledForSearchBar) {
                    <app-add-parts-to-cart
                      [systemDetails]="currentCart.attributes.systemDetails"
                      [disabledAddButton]="isAddingViaCsvInProgress"
                      (uploadedFilesViaSearchBar)="addToCartViaSearchBar($event)">
                    </app-add-parts-to-cart>
                  }
                </div>
                <div class="add-via-drag-drop-container">
                  @if (featureIsEnabledForCsv) {
                    <app-drag-drop-upload
                      [uploadHeaderText]="'drag-drop.cart-upload-headline'"
                      [supportedMaxAmountOfFiles]="1"
                      [supportedFileFormates]="['.csv']"
                      [uploadingFileInProgress]="isAddingViaCsvInProgress"
                      [disabledAddButton]="disabledAddToCartSearchBar"
                      [showDownloadCsvTemplateButton]="true"
                      [showUploadButton]="true"
                      [fullFramePadding]="true"
                      (uploadedFiles)="addToCartViaCsv($event)">
                    </app-drag-drop-upload>
                  }
                </div>
              </div>
            }
          </div>
